<div class="gravatar" [ngClass]="{ stacked: isStacked }" [style]="{ borderColor: randomBorderColor }">
  <span *ngIf="isNotificationOn" class="gravatar__notification-dot"></span>
  <span class="gravatar__initials">{{ acronymText | uppercase | slice : 0 : 2 }}</span>
</div>
